import React, { useState, useEffect } from 'react';
import PageContainer from '../../../components/PageContainer';
import { Box, Button, Chip } from '@mui/material';
import { Add } from '@mui/icons-material';
import { Link } from 'react-router-dom';
import appRoutes from '../../../routes/routeConfig';
import Filters from '../../../components/Filters';
import { DataGrid } from '@mui/x-data-grid';
import moment from 'moment';
import { getStatusColor } from '../../../util';
import { useSnackbar } from 'notistack';

const InstitutionAdmins = () => {
    const { enqueueSnackbar } = useSnackbar();
    const [processing, setProcessing] = useState(false);
    const [records, setRecords] = useState([]);

    const columns = [
        {
            field: 'sn',
            headerName: 'S/N',
            width: 100,
            sortable: false,
            renderCell: (params) => {
                return (
                    <p style={{ margin: 'auto' }}>
                        {(params?.api?.getRowIndex(params?.row?.id) || 0) + 1}
                    </p>
                );
            },
        },
        // { field: 'employeeId', headerName: 'Employee Id', width: 150 },
        { field: 'firstName', headerName: 'First Name', width: 200 },
        { field: 'lastName', headerName: 'Last Name', width: 200 },
        {
            field: 'institutionName',
            headerName: 'Institution Name',
            width: 300,
        },
        {
            field: 'account_status',
            headerName: 'Status',
            width: 150,
            renderCell: (params) => (
                <Chip
                    size="small"
                    color={getStatusColor(
                        params?.row?.isActive ? 'active' : 'inactive'
                    )}
                    label={
                        <small>
                            {params?.row?.isActive ? 'Active' : 'Inactive'}
                        </small>
                    }
                />
            ),
        },
        { field: 'email', headerName: 'Email', width: 250 },
        { field: 'phoneNumber', headerName: 'Phone Number', width: 150 },
        {
            field: 'createdDate',
            headerName: 'Creation Date',
            width: 200,
            valueGetter: (params) =>
                moment(params?.row?.createdDate).format('DD MMMM, YYYY'),
        },
    ];

    const init = async () => {
        try {
            setProcessing(true);
            // const res = await getAllSubcategories();
            // setRecords(res?.resultObject || []);
        } catch (err) {
            enqueueSnackbar(err?.message || 'An error occurred', {
                variant: 'error',
            });
        } finally {
            setProcessing(false);
        }
    };

    useEffect(() => {
        init();
    }, []);

    return (
        <PageContainer
            pageTitle="Institution Administrators"
            tagline="Manage all institution admins"
            processing={processing}
            buttonComponent={
                <>
                    {/* <Link to={appRoutes.internal.users.createInstitutionAdmins}>
                    <Button startIcon={<Add />} variant='contained'>Create Admin</Button>
                </Link> */}
                </>
            }
        >
            <Box>
                <div
                    className="paper"
                    style={{ height: 650, width: '100%', textAlign: 'center' }}
                >
                    <DataGrid
                        className={'center-first-column'}
                        rows={records}
                        getRowId={(row) => row.id}
                        columns={columns}
                        pageSize={10}
                        rowsPerPageOptions={[10]}
                        checkboxSelection={false}
                        disableSelectionOnClick
                    />
                </div>
            </Box>
        </PageContainer>
    );
};

export default InstitutionAdmins;
